<template>
  <div v-if="!$route.meta.isMain">
    <RouterView />
  </div>
  <main
    v-else
    class="main-page"
  >
    <div class="container">
      <div class="header">
        Notice to AUT Token Holders
      </div>

      <div>
        <p>
          AUT Token project has been formally closed following the cessation of Autentic Capital’s operations as an independent entity. All matters related to claim verification and potential compensation have been transferred to an independent partner, RWA Chain.
        </p>
        <p>
          To participate in the process, please complete the online form and provide information confirming your AUT Token purchase.
        </p>
        <p>
          Submission period: until February 15, 2026 (inclusive). Requests submitted after this date will not be accepted.
        </p>
      </div>

      <div class="button-wrap">
        <a
          href="https://rwapo.com/submit"
          class="submit-button "
        >
          <AuButton
            class="btn_agree"
            padding="12px 43px"
            font-size="18px"
            text-color-active="#fff"
          >
            Submit
          </AuButton>
        </a>
      </div>
    </div>

    <div class="container login-container">
      <a
        href="https://aut.finance/login/ru"
        class="login-button"
      >
        Login
      </a>
    </div>
  </main>
</template>

<style scoped lang="scss">
.main-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;
  overflow: hidden;
  background: linear-gradient(to left, #DAEDF3, #FFFFFF 75%);

  height: 100vh;

  font-weight: 400;
  font-size: 22px;
  line-height: 28px;

  p {
    margin-bottom: 20px;
  }
}

.container {
  margin-top: 100px;
  padding: 0px 150px;

  @media screen and (max-width: 1800px) {
    padding: 0 100px;
  }

  @media screen and (max-width: 1200px) {
    padding: 0 30px;
  }

  .header {
    font-size: 38px;
    margin-bottom: 40px;
  }

  .button-wrap {
    display: flex;
    justify-content: end;

    width: 100%;

    .submit-button {
      text-decoration: none;
    }
  }
}

.login-container {
  margin-bottom: 15px;
  width: fit-content;
}

.login-button {
  color: #DAEDF3;
  text-decoration: none;
}
</style>